import React from 'react';

const WorkflowTriggerUserFormModal = React.lazy(() => import('../components/FormModal'));
const workflowTriggerUserModalRegistry = {
    crm_workflowTriggerUserId: WorkflowTriggerUserFormModal
};
export default workflowTriggerUserModalRegistry;
